module.exports = __webpack_public_path__ + "assets/2ac640d067b96fdb3706481add08ed5f.mp3";